import React from 'react'
import { Ghost, List, Separator } from '@fs/zion-ui'
import { SessionCard } from '../card'

export default function CardList({
  Component = SessionCard,
  headingLevel = 'h3',
  as = 'li',
  items,
  linkPage,
  ...props
}) {
  if (!items) return null

  return (
    <List>
      {items.map((item) => {
        return (
          <Ghost key={item.id} as={as} heightEstimate={300} style={{ paddingInlineStart: 0, margin: 0 }} keepVisible>
            <Component data={item} headingLevel={headingLevel} linkPage={linkPage} {...props} />
            <Separator />
          </Ghost>
        )
      })}
    </List>
  )
}
